import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'kx-camera-audio-permssion',
    templateUrl: './camera-audio-permssion.component.html',
    styleUrls: ['./camera-audio-permssion.component.scss'],
    standalone: false
})
export class CameraAudioPermssionComponent implements OnInit {
  @Input() device: any ="camera";
  @Input() resource: any = "Tele-consultation"
  @Output() closedevicePopup = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    console.log("inside camera seetings")
  }

  closePopup() {
    this.closedevicePopup.emit(true);
  }
}
